import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  UPDATE_LOGIN
} from "../types.js";

import { LOGOUT_LINK, LOGIN_CHECK_LINK } from "../links.js";

export const loginSuccess = json => ({
  type: LOGIN_SUCCESS,
  payload: { loginName: json.loginname, securityToken: json.securitytoken }
});

export const loginFailure = error => ({
  type: LOGIN_FAILURE,
  payload: error
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
});

export const logoutFailure = error => ({
  type: LOGOUT_FAILURE,
  payload: error
});

export const updateLoginInfo = json => ({
  type: UPDATE_LOGIN,
  payload: { loginName: json.loginname, securityToken: json.securitytoken }
});

export const fetchLogin = securitytoken => {
  var form = new FormData();
  form.append("securitytoken", securitytoken);

  return dispatch => {
    fetch(LOGIN_CHECK_LINK, {
      headers: {
        Accept: "*/*"
      }
    })
      .then(res => res.json())
      .then(json => dispatch(loginSuccess(json.__Result)))
      .catch(error => dispatch(loginFailure(error)));
  };
};

export const handleLogout = securitytoken => {
  return dispatch => {
    var form = new FormData();
    form.append("securitytoken", securitytoken);

    fetch(LOGOUT_LINK, {
      method: "POST",
      body: form,
      headers: {
        Accept: "*/*",
        credentials: "same-origin"
      },
      mimeType: "multipart/form-data",
      data: form
    }).then(json => {
      //console.error("TEST FORM", json);
      dispatch(logoutSuccess());
    });
  };
};
